import { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { EditPage, EditPagePanel, EditPageTextField, EditPageTextArea } from '../../../../common/EditPage';
import { useParams, useNavigate } from 'react-router-dom';
import { getOne, update } from '../../../../common/v4/BackendProvider';
import { toast } from 'react-toastify';

const AccessGroupsEdit = () => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const navigate = useNavigate();
    const { groupId } = useParams();
    
    useEffect(() => {
        getOne(`/admin/access/groups/`, groupId).then(response => {
            setMetadata(response.data.metadata);
            setData(response.data.data);
        }).catch(error => {
            toast.error("Error fetching access group: " + error.message, {});
        });
    }, [groupId]);

    const handleSave = () => {
        update(`/admin/access/groups/`, groupId, {data: data}).then(() => {
            navigate(`/admin/access/groups`);
        }).catch(error => {
            toast.error("Error updating access group: " + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate(`/admin/access/groups`);
    };

    const onChange = (id, value) => {
        setData({...data, [id]: value});
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={handleSave} handleCancel={handleCancel}>
                <EditPagePanel>
                    <EditPageTextField 
                        label="Name" 
                        id="name" 
                        onChange={onChange} 
                        value={data.name} 
                        required
                    />
                    <EditPageTextArea 
                        label="Description" 
                        id="description" 
                        onChange={onChange} 
                        value={data.description}
                        rows={3}
                    />
                </EditPagePanel>
            </EditPage>
        </>
    )
}

export default AccessGroupsEdit; 